'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var arrowLeftChevron = require('./arrow-left-chevron-4cbe9905.js');

var IconWrapper = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n\n  ", "\n\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var isRootPlaceholder = _a.isRootPlaceholder;
    return !isRootPlaceholder && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    margin-right: 12px;\n  "], ["\n    margin-right: 12px;\n  "])));
}, function (_a) {
    var isRootPlaceholder = _a.isRootPlaceholder;
    return isRootPlaceholder && styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    width: 56px;\n    margin-left: -12px;\n    margin-right: 0px;\n  "], ["\n    width: 56px;\n    margin-left: -12px;\n    margin-right: 0px;\n  "])));
});
var ExpandIcon = styled__default(arrowLeftChevron.ArrowLeftChevron)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  transition-duration: 0.25s;\n  transition-property: transform;\n  transition-timing-function: ease-in-out;\n\n  ", "\n"], ["\n  transition-duration: 0.25s;\n  transition-property: transform;\n  transition-timing-function: ease-in-out;\n\n  ",
    "\n"])), function (_a) {
    var expanded = _a.expanded;
    return (expanded
        ? styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["transform: rotate(270deg);"], ["transform: rotate(270deg);"]))) : styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["transform: rotate(180deg);"], ["transform: rotate(180deg);"]))));
});
var CellPlaceholder = function (_a) {
    var expandable = _a.expandable, _b = _a.nestingLevel, nestingLevel = _b === void 0 ? 0 : _b, expanded = _a.expanded, onClick = _a.onClick;
    return (expandable ? (React__default.createElement(IconWrapper, { isRootPlaceholder: nestingLevel === 0 },
        React__default.createElement(ExpandIcon, { expanded: expanded, size: "xs", variant: "adminGreyDark", onClick: onClick, "data-testid": "expand-icon" }))) : null);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.CellPlaceholder = CellPlaceholder;
